import { createAction, createActionGroup, props } from '@ngrx/store';
import { IProject, IProjectsResponse } from '../interfaces';

const accessSettingsActions = createActionGroup({
  source: 'Access Settings',
  events: {
    'Get Projects': props<{ isShowMore: boolean }>(),
    'Get Projects Success': props<{ isShowMore: boolean; projects: IProjectsResponse }>(),
  },
});

export enum AccessSettingsActionTypes {
  GET_PROJECTS_FAILURE = '[Access Settings] Get Projects Failure',

  GET_MEMBERS = '[Access Settings] Get Members',
  GET_MEMBERS_SUCCESS = '[Access Settings] Get Members Success',
  GET_MEMBERS_FAILURE = '[Access Settings] Get Members Failure',

  REMOVE_MEMBER = '[Access Settings] Remove Member',
  REMOVE_MEMBER_SUCCESS = '[Access Settings] Remove Member Success',
  REMOVE_MEMBER_FAILURE = '[Access Settings] Remove Member Failure',

  CHANGE_STATUS_MEMBER = '[Access Settings] Change Status Member',
  CHANGE_STATUS_MEMBER_SUCCESS = '[Access Settings] Change Status Member Success',
  CHANGE_STATUS_MEMBER_FAILURE = '[Access Settings] Change Status Member Failure',

  INVITE_MEMBERS = '[Access Settings] Invite Members',
  INVITE_MEMBERS_SUCCESS = '[Access Settings] Invite Members Success',
  INVITE_MEMBERS_FAILURE = '[Access Settings] Invite Members Failure',
}
export const { getProjects, getProjectsSuccess } = accessSettingsActions;

export const getProjectsFailure = createAction(AccessSettingsActionTypes.GET_PROJECTS_FAILURE);

export const getMembers = createAction(AccessSettingsActionTypes.GET_MEMBERS, props<{ id: number }>());

export const getMembersSuccess = createAction(
  AccessSettingsActionTypes.GET_MEMBERS_SUCCESS,
  props<{ project: IProject }>(),
);

export const getMembersFailure = createAction(AccessSettingsActionTypes.GET_MEMBERS_FAILURE);

export const removeMember = createAction(
  AccessSettingsActionTypes.REMOVE_MEMBER,
  props<{ projectId: number; id: number; isMember: boolean }>(),
);

export const removeMemberSuccess = createAction(
  AccessSettingsActionTypes.REMOVE_MEMBER_SUCCESS,
  props<{ projectId: number; id: number; isMember: boolean }>(),
);

export const removeMemberFailure = createAction(AccessSettingsActionTypes.REMOVE_MEMBER_FAILURE);

export const changeStatusMember = createAction(
  AccessSettingsActionTypes.CHANGE_STATUS_MEMBER,
  props<{ projectId: number; id: number; active: boolean }>(),
);

export const changeStatusMemberSuccess = createAction(
  AccessSettingsActionTypes.CHANGE_STATUS_MEMBER_SUCCESS,
  props<{ projectId: number; id: number; active: boolean }>(),
);

export const changeStatusMemberFailure = createAction(AccessSettingsActionTypes.CHANGE_STATUS_MEMBER_FAILURE);

export const inviteMembers = createAction(
  AccessSettingsActionTypes.INVITE_MEMBERS,
  props<{ emails: string[]; idProject: number }>(),
);

export const inviteMembersSuccess = createAction(
  AccessSettingsActionTypes.INVITE_MEMBERS_SUCCESS,
  props<{ countMembers: number; idProject: number }>(),
);

export const inviteMembersFailure = createAction(AccessSettingsActionTypes.INVITE_MEMBERS_FAILURE);
